"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactCountryFlags = _interopRequireDefault(require("react-country-flags"));
var _commonAccordion = require("@mmc/common-accordion");
var _countryDropdown = _interopRequireDefault(require("../styles/country-dropdown.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var renderCountryLink = function renderCountryLink(item, alternateCharSetLanguages) {
  var latinCharsLangRegExp = /\([A-Z]\w+\)/;
  var latinCharsLang = item.name.match(latinCharsLangRegExp);
  var cssLang = alternateCharSetLanguages.includes(item.language) ? item.language : 'DEFAULT';
  return /*#__PURE__*/_react["default"].createElement("li", {
    key: item.link
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: item.link,
    className: _countryDropdown["default"].countryDropdownLinkItem
  }, /*#__PURE__*/_react["default"].createElement(_reactCountryFlags["default"], {
    country: item.flag
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontFamily: "MMC-Regular-" + cssLang + ", 'MMC-Regular', Arial, Helvetica, Verdana, sans-serif;"
    }
  }, item.name.replace(latinCharsLangRegExp, '')), latinCharsLang && /*#__PURE__*/_react["default"].createElement("span", {
    className: _countryDropdown["default"].latinCharsLang
  }, latinCharsLang[0])));
};
var renderPanelHeader = function renderPanelHeader(region, i, theme) {
  return /*#__PURE__*/_react["default"].createElement("h3", {
    key: i + "-header"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: theme.headingSix
  }, region.regionName));
};
var renderPanelBody = function renderPanelBody(region, i, alternateCharSetLanguages) {
  return /*#__PURE__*/_react["default"].createElement("ul", {
    key: i + "-panel",
    className: _countryDropdown["default"].countryDropdownInnerList
  }, region.countries.map(function (countryData) {
    return renderCountryLink(countryData, alternateCharSetLanguages);
  }));
};
var renderPanels = function renderPanels(marketLinks, theme, alternateCharSetLanguages) {
  if (marketLinks === void 0) {
    marketLinks = [];
  }
  var regionMarkup = [];
  marketLinks.forEach(function (region, i) {
    regionMarkup.push(renderPanelHeader(region, i, theme));
    regionMarkup.push(renderPanelBody(region, i, alternateCharSetLanguages));
  });
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, regionMarkup);
};
var renderRegions = function renderRegions(marketLinks, theme, alternateCharSetLanguages) {
  return /*#__PURE__*/_react["default"].createElement(_commonAccordion.CommonAccordion, {
    theme: theme,
    multiselectable: false,
    panelClasses: [_countryDropdown["default"].tabPanel, _countryDropdown["default"].smallPanel]
  }, renderPanels(marketLinks, theme, alternateCharSetLanguages));
};
var FooterCountryDropdown = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(FooterCountryDropdown, _Component);
  function FooterCountryDropdown(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.handleCheckForDismiss = _this.handleCheckForDismiss.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = FooterCountryDropdown.prototype;
  _proto.handleCheckForDismiss = function handleCheckForDismiss() {
    var handleCollapseCountryModal = this.props.handleCollapseCountryModal;
    handleCollapseCountryModal();
  };
  _proto.render = function render() {
    var _this$props = this.props,
      theme = _this$props.theme,
      data = _this$props.data,
      handleCollapseCountryModal = _this$props.handleCollapseCountryModal,
      isActive = _this$props.isActive,
      alternateCharSetLanguages = _this$props.alternateCharSetLanguages;
    return /*#__PURE__*/_react["default"].createElement("div", {
      id: "RegionSelector",
      className: _countryDropdown["default"].countryDropdownWrapper + " " + (isActive ? _countryDropdown["default"].isActive : '')
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: _countryDropdown["default"].backgroundDismiss,
      onClick: this.handleCheckForDismiss
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _countryDropdown["default"].srOnly
    }, data.closeLabel)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _countryDropdown["default"].countryDropdownPanel + " " + theme['container-fluid']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _countryDropdown["default"].countryDropdownInnerContainer + " " + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-10'] + " " + theme['col-sm-offset-1']
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: _countryDropdown["default"].countryDropdownTitle + " " + theme.headingTwo
    }, data.titleText), renderRegions(data.regions, theme, alternateCharSetLanguages), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.dark + " " + _countryDropdown["default"].closeButtonWrapper
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: theme.mmcIconClose + " " + _countryDropdown["default"].countryDropdownClose,
      onClick: handleCollapseCountryModal
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _countryDropdown["default"].srOnly
    }, data.closeLabel)))))));
  };
  return FooterCountryDropdown;
}(_react.Component);
var _default = FooterCountryDropdown;
exports["default"] = _default;